import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import * as models from "../model";

import * as actions from "./actiontypes";
import { PartiallyMatchedEmployeeApi } from "./partiallyMatchedEmployeeApi";

export type PartiallyMatchedEmployeeAction =
      ({ type: typeof actions.LOAD_PARTIALLY_MATCHED_EMPLOYEES_SUCCESS } & Payload<models.PartiallyMatchedEmployeeListModel[]>)
    | ({ type: typeof actions.LOAD_PARTIALLY_MATCHED_EMPLOYEE_DETAIL_SUCCESS } & Payload<models.PartiallyMatchedEmployeeDetailModel>)
    | ({ type: typeof actions.MATCH_EMPLOYEE_TO_EMPLOYEE_RECORD_SUCCESS } & Payload<any>)
    | ({ type: typeof actions.MATCH_EMPLOYEE_TO_NEW_EMPLOYEE_RECORD_SUCCESS } & Payload<any>);

export function loadPartiallyMatchedEmployees() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadPartiallyMatchedEmployees", PartiallyMatchedEmployeeApi.getAll());
        dispatch(loadPartiallyMatchedEmployeesSuccess(result));
    };
}

export const loadPartiallyMatchedEmployeesSuccess = (payload: models.PartiallyMatchedEmployeeListModel[]): PartiallyMatchedEmployeeAction => ({
    payload,
    type: actions.LOAD_PARTIALLY_MATCHED_EMPLOYEES_SUCCESS
});

export const loadPartiallyMatchedEmployeeDetailSuccess =
    (payload: models.PartiallyMatchedEmployeeDetailModel): PartiallyMatchedEmployeeAction => ({
        payload,
        type: actions.LOAD_PARTIALLY_MATCHED_EMPLOYEE_DETAIL_SUCCESS
    });

export const matchEmployeeToEmployeeRecordSuccess = (payload: any): PartiallyMatchedEmployeeAction => ({
    payload,
    type: actions.MATCH_EMPLOYEE_TO_EMPLOYEE_RECORD_SUCCESS
});

export const matchEmployeeToNewEmployeeRecordSuccess = (payload: any): PartiallyMatchedEmployeeAction => ({
    payload,
    type: actions.MATCH_EMPLOYEE_TO_NEW_EMPLOYEE_RECORD_SUCCESS
});
